
import { Product } from '@/types/product';
import { ProductCard } from './ProductCard';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

interface ProductCategoryRowProps {
  title: string;
  products: Product[];
  onViewAll?: () => void;
  className?: string;
  limit?: number;
}

export function ProductCategoryRow({ 
  title, 
  products, 
  onViewAll, 
  className = '', 
  limit = 4 
}: ProductCategoryRowProps) {
  if (products.length === 0) return null;

  const productsToShow = products.slice(0, limit);

  return (
    <div className={`py-4 md:py-6 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl md:text-2xl font-bold tracking-tight">{title}</h2>
        {onViewAll && products.length > limit && (
          <Button variant="ghost" onClick={onViewAll} className="text-primary hover:text-primary whitespace-nowrap text-sm">
            View All ({products.length}) <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5 lg:gap-6">
        {productsToShow.map(product => (
          <ProductCard
            key={product.id}
            {...product}
            tags={[product.category]}
          />
        ))}
      </div>
    </div>
  );
}
